import { Modal, Input } from '@trackman/web-shared-components';
import { useEffect, useRef, useState } from 'react';

type Props = {
  open: boolean;
  currentName: string;
  onClose: (newName: string | null) => Promise<void>;
};

export const RenameDialog = ({ open, currentName, onClose }: Props) => {
  const [name, setName] = useState(currentName);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (open) {
      setName(currentName);
      setTimeout(() => {
        inputRef.current?.focus();
        inputRef.current?.select(); // Select all like Windows rename
      }, 0);
    }
  }, [open, currentName]);

  const handleConfirm = () => {
    const trimmed = name.trim();
    if (trimmed) {
      onClose(trimmed);
    }
  };

  const handleCancel = () => {
    onClose(null);
  };

  return (
    <Modal
      className="admin-modal"
      open={open}
      title="Rename Item"
      onClose={handleCancel}
      cancelBtn={{ label: 'Cancel', onClick: handleCancel }}
      confirmBtn={{
        label: 'Rename',
        onClick: handleConfirm,
        disabled: !name.trim(),
      }}
    >
      <div className="modal-body">
        <Input
          label="New name"
          value={name}
          inputRef={inputRef}
          onChange={e => setName(e.currentTarget.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleConfirm();
            }
          }}
        />
      </div>
    </Modal>
  );
};
